import { render, staticRenderFns } from "./LeftBlock.vue?vue&type=template&id=07f1b773&scoped=true&"
import script from "./LeftBlock.vue?vue&type=script&lang=ts&"
export * from "./LeftBlock.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBlock.vue?vue&type=style&index=0&id=07f1b773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1b773",
  null
  
)

export default component.exports